<template>
  <div class="turnstile-widget">
    <div ref="containerRef" class="turnstile-widget__container"></div>
    <p v-if="error" class="turnstile-widget__error">{{ error }}</p>
  </div>
</template>

<script setup lang="ts">
import { loadTurnstile } from "@/lib/turnstile";
import { onBeforeUnmount, onMounted, ref } from "vue";

const props = defineProps<{
  siteKey: string;
  modelValue?: string;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

const containerRef = ref<HTMLElement | null>(null);
const error = ref("");
let widgetId: string | null = null;

onMounted(async () => {
  if (!containerRef.value) {
    return;
  }

  try {
    const turnstile = await loadTurnstile(props.siteKey);
    if (!containerRef.value) {
      return;
    }

    widgetId = turnstile.render(containerRef.value, {
      sitekey: props.siteKey,
      theme: "auto",
      callback: (token: string) => {
        error.value = "";
        emit("update:modelValue", token);
      },
      "expired-callback": () => {
        emit("update:modelValue", "");
      },
      "error-callback": () => {
        emit("update:modelValue", "");
        error.value = "Не удалось пройти проверку Cloudflare Turnstile. Попробуйте еще раз.";
      },
    });
  } catch (reason) {
    error.value = reason instanceof Error ? reason.message : "Не удалось загрузить Cloudflare Turnstile.";
  }
});

onBeforeUnmount(() => {
  emit("update:modelValue", "");
  if (widgetId) {
    window.turnstile?.reset(widgetId);
  }
});
</script>

<style scoped lang="scss">
.turnstile-widget {
  display: grid;
  gap: 8px;
}

.turnstile-widget__container {
  min-height: 70px;
}

.turnstile-widget__error {
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: #ef4444;
}
</style>
